module.exports = __webpack_public_path__ + "static/media/S3C3.0772c09a.svg";